import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ko from './locales/ko.json'
import en from './locales/en.json'

export const SUPPORTED_LANGS = ['ko', 'en'] as const
export type Lang = (typeof SUPPORTED_LANGS)[number]

const STORAGE_KEY = 'lang'

/** 저장된 언어 → 브라우저 언어(ko 로 시작하면 한국어, 그 외 영어) 순으로 정한다. */
function detectLanguage(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'ko' || saved === 'en') return saved
  } catch {
    /* 저장소 접근이 막힌 환경 - 브라우저 언어로 */
  }
  return typeof navigator !== 'undefined' && navigator.language?.toLowerCase().startsWith('ko') ? 'ko' : 'en'
}

void i18n.use(initReactI18next).init({
  resources: { ko: { translation: ko }, en: { translation: en } },
  lng: detectLanguage(),
  fallbackLng: 'ko',
  interpolation: { escapeValue: false }, // React 가 이스케이프한다
  returnNull: false,
})

document.documentElement.lang = i18n.language

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
  try {
    localStorage.setItem(STORAGE_KEY, lng)
  } catch {
    /* 저장 실패는 무시 - 다음 방문에 브라우저 언어로 돌아간다 */
  }
})

export function setLanguage(lang: Lang) {
  void i18n.changeLanguage(lang)
}

/** 컴포넌트 밖(모듈 함수, 이벤트 핸들러 등)에서 번역할 때 쓴다. 컴포넌트 안에서는 useTranslation 을 쓴다. */
export const translate = i18n.t.bind(i18n)

export default i18n
